import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {
    Button,
    Form,
    Container,
    Header,
    Breadcrumb, Grid
} from 'semantic-ui-react';
import {Helmet} from "react-helmet";
import auth from "../../data/auth";

import CustomDivider from '../../components/extras/CustomDivider';
import Toast from "../../components/extras/Toast";

class ChangePassword extends Component {

    constructor() {
        super();

        this.state = {
            new_password: '',
            re_password: '',
            current_password: '',
            new_password_error: false,
            re_password_error: false,
            current_password_error: false,
            sending_button: false
        };

        this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
        this.handleRePasswordChange = this.handleRePasswordChange.bind(this);
        this.handleCurrentPasswordChange = this.handleCurrentPasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.current_password === "") {
            this.setState({current_password_error: true});
        } else if (this.state.new_password === '') {
            this.setState({new_password_error: true});
        } else if (this.state.re_password === '') {
            this.setState({re_password_error: true});
        } else {
            this.setState({sending_button: true});
            auth.changePassword(this.state.new_password, this.state.re_password, this.state.current_password, (res) => {
                if (res.hasOwnProperty('current_password')) {
                    this.setState({current_password:''});
                    this.refs.toast.show({message: 'Contraseña incorrecta!', type: 'error'});
                } else if (res.hasOwnProperty('non_field_errors')) {
                    this.refs.toast.show({message: 'Las contraseñas no coinciden!', type: 'error'});
                } else {
                    this.setState({
                        current_password:'',
                        re_password:'',
                        new_password:'',
                    });
                    this.refs.toast.show({message: 'Contraseña Actualizada!', type: 'success'});
                }
                this.setState({sending_button: false});
            });

        }
    }

    handleNewPasswordChange(event) {
        this.setState({new_password: event.target.value});
        if (event.target.value.trim() === '') {
            this.setState({new_password_error: true});
        } else {
            this.setState({new_password_error: false});
        }
    };

    handleCurrentPasswordChange(event) {
        this.setState({current_password: event.target.value});
        if (event.target.value.trim() === '') {
            this.setState({current_password_error: true});
        } else {
            this.setState({current_password_error: false});
        }
    };

    handleRePasswordChange(event) {
        this.setState({re_password: event.target.value});
        if (event.target.value.trim() === '') {
            this.setState({re_password_error: true});
        } else {
            this.setState({re_password_error: false});
        }
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Cambiar Contraseña | Seguridad - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/security'>Seguridad</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Cambiar Contraseña</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Container>
                    <Header as='h2'>
                        <Header.Content>
                            Cambiar Contraseña
                        </Header.Content>
                    </Header>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Form onSubmit={this.handleSubmit}>
                                    <Form.Input type='password' label='Antigua Contraseña' placeholder='Antigua Contraseña'
                                                value={this.state.current_password} onChange={this.handleCurrentPasswordChange}
                                                error={this.state.current_password_error} />
                                    <Form.Input type='password' label='Nueva Contraseña' placeholder='Nueva Contraseña'
                                                value={this.state.new_password} onChange={this.handleNewPasswordChange}
                                                error={this.state.new_password_error}/>
                                    <Form.Input type='password' label='Repetir Contraseña' placeholder='Repetir Contraseña'
                                                value={this.state.re_password} onChange={this.handleRePasswordChange}
                                                error={this.state.re_password_error}/>
                                    <Button primary fluid disabled={this.state.sending_button} loading={this.state.sending_button} type="submit"
                                            content="Actualizar Contraseña"/>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Toast ref='toast'/>
                </Container>
            </div>
        );
    }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/containers/security/ChangePassword.js